import { HicChip } from './hic-chip'

export default function HicChipForTag({ label, color }: { label: string; color: string }) {
  return <HicChip text={label} color="white" borderColor={color} borderStyle="solid" />
}
